import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { withRouter } from 'react-router';
import qs from 'qs';
import axios from 'axios';
import { fetchTextures, fetchLatestTextures, fetchCategoryTags } from '../../actions';
import TextureModal from '../textureModal/TextureModal';
import categoryListImport from '../categoryList';
import SubcategorySelection from './SubcategorySelection';
import FilterByTag from './FilterByTag';
import Gallery from './Gallery';

const categoryList = new Map(categoryListImport);
class TextureGallery extends Component {
  resize = debounce(() => {
    if (this.list.current) {
      this.computeRows();
    }
  }, 200);

  constructor(props) {
    super(props);
    this.list = React.createRef();
  }

  state = {
    modal: false,
  };

  componentDidMount() {
    if (this.props.match.params.id) this.fetchTextures();
    if (this.props.latestTextures) this.fetchLatestTextures();
    if (this.props.location.search) {
      this.initModal();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.fetchTextures();
    }
    if (this.props.location.search !== prevProps.location.search) {
      this.fetchTextures();
    }
  }

  fetchLatestTextures = async () => {
    await this.props.fetchLatestTextures();
  };

  fetchTextures = async () => {
    const { id, subcategories, category } = this.props.match.params;

    let categories = [id];
    let children = [];
    const tags =
      qs.parse(this.props.history.location.search, {
        ignoreQueryPrefix: true,
      }).tags || [];
    if (category) {
      const parent = categoryList.get(parseInt(id, 10));

      categories = [parent.id, ...new Map(parent.children).keys()];

      children = [parent, ...new Map(parent.children).values()];
    }
    if (subcategories) {
      categories = subcategories.split(',').map(cat => parseInt(cat, 10));
    }
    if (id) {
      this.props.fetchTextures({ category_id: categories, tags });
    }
    this.setState({ categories: children, category_ids: categories });
    this.props.fetchCategoryTags(categories);
  };

  initModal = async () => {
    const texture = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    const res = await axios.get('/api/fetch_textures', {
      params: { textureKey: texture.texture },
    });
    this.openModal(res.data[0]);
  };

  openModal = texture => {
    this.setState({
      modal: true,
      texture,
    });
    // push to texture.ninja/cat/brick/texture=
    // console.log(texture);
    this.props.history.push({ search: qs.stringify({ texture: texture.key }) });
  };

  closeModal = () => {
    this.setState({ modal: false });
    this.props.history.push({ search: '' });
  };

  toggleSelection = newId => {
    const { category, id, subcategories } = this.props.match.params;
    const selection = subcategories ? subcategories.split(',') : [];
    const index = selection.indexOf(newId.toString());
    if (index > -1) {
      selection.splice(index, 1);
    } else {
      selection.push(newId);
    }

    this.props.history.push({
      pathname: `/category/${category}/${id}/${selection.toString()}`,
    });
  };

  render() {
    const { textures, match, auth, tags, saved, latestTextures } = this.props;
    const { categories, modal, texture, category_ids } = this.state;
    return (
      <Fragment>
        {modal && <TextureModal texture={texture} modal={modal} onClose={this.closeModal} />}
        {categories && (
          <SubcategorySelection
            selection={match.params.subcategories || ''}
            toggleSelection={this.toggleSelection}
            categories={categories}
          />
        )}
        {category_ids && <FilterByTag tags={tags} category_ids={category_ids} />}

        <Gallery
          latestTextures={latestTextures}
          openModal={this.openModal}
          textures={saved || textures}
          auth={auth}
        />
      </Fragment>
    );
  }
}

function mapStateToProps({ textures, auth, tags }) {
  return { textures, auth, tags };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      fetchTextures,
      fetchLatestTextures,
      fetchCategoryTags,
    }
  )(TextureGallery)
);



// WEBPACK FOOTER //
// ./src/components/gallery/TextureGallery.js